<template>
  <section :class="wrapperClass">
    <HealthLabel
      v-if="label"
      :class="classLabel"
      :label="label"
      :required="required"
      :for="forLabel"
    />
    <slot :error="error" :for-label="forLabel" />
    <HealthErrors v-if="error && showErrorMessage" :error="error" :error-message="errorMessage" />
  </section>
</template>

<script setup lang="ts">
  import HealthLabel from "@/shared/components/form/HealthLabel.vue";
  import HealthErrors from "@/shared/components/form/HealthErrors.vue";
  import { computed, useId } from "vue";

  const props = defineProps({
    label: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: "",
    },
    forLabel: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    showErrorMessage: {
      type: Boolean,
      default: true,
    },
    wrapperClass: {
      type: [String, Array, Object],
      default: "flex flex-col gap-1",
    },
    classLabel: {
      type: String,
      default: "font-semibold text-sm md:text-base mr-auto",
    },
  });

  const uniqueId = useId();

  const forLabel = computed(() => {
    return (
      props.forLabel ||
      (props.label ? `${props.label.replace(/\s+/g, "-").toLowerCase()}-${uniqueId}` : uniqueId)
    );
  });
</script>
